/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import mail from "../assets/images/mail.svg";
import phone from "../assets/images/phone.svg";
import map from "../assets/images/map.svg";
import "./Contact.css";
import { Fade } from "react-reveal";

export default function Contact() {
  return (
    <div id="contact">
      <div className="servicesSec container-fluid">
        <Fade bottom>
          <div className="servicesCard">
            <h3>تواصل معنا</h3>
            <div className="row">
              <div className="col-md-4">
                <div className="contact-icons">
                  <img src={mail} alt="email" />
                  <a href="mailto:valuation.om@valuexperts.net">
                    valuation.om@valuexperts.net
                  </a>
                </div>
              </div>
              <div className="col-md-4">
                <div className="contact-icons borderCenter">
                  <img src={phone} alt="phone" />
                  <a href="tel:+96872277904">96872277904+</a>
                  <a href="tel:+96872727860">96872727860+</a>
                </div>
              </div>
              <div className="col-md-4">
                <div className="contact-icons">
                  <img src={map} alt="map" />
                  <a href="#">Al Khuwair South - Oman</a>
                </div>
              </div>
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-5">
                    <div className="contactForm">
                      <div className="form-group">
                        <label>الاسم</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label>رقم الهاتف</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label>البريد الالكتروني</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="contactForm">
                      <div className="form-group">
                        <label className="msgLabel">الرسالة</label>
                        <textarea className="form-control"></textarea>
                      </div>
                      <button type="submit" className="btn">
                        ارسال
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
}
